import { Injectable, inject } from '@angular/core';
import { PlatformService } from '../shared/services/platform-service';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { OidcSecurityService } from './auth-oidc-client/services/oidc.security.service';
import { LoginInput } from '@api/models/login-input';
import { LoginResponse } from '@api/models/login-response';
import { LoginRequest } from '@api/models/login-request';
import { LoginFailure } from '@app/state/account/account.actions';
import { UrlHelper } from '@env/url-helper';

@Injectable()
export class AuthenticateService {
  private platformService = inject(PlatformService);
  private httpClient = inject(HttpClient);
  private store = inject(Store);
  private oidcSecurityService = inject(OidcSecurityService);
  private urlHelper = inject(UrlHelper);

  async registerOrLogin(email: string, password: string) {
    await this.commonRegisterOrLogin(false, email, password);
  }

  async guestCheckout(email: string) {
    await this.commonRegisterOrLogin(true, email, crypto.randomUUID());
  }

  private async commonRegisterOrLogin(isFastCheckout: boolean, email: string, password: string) {
    const loginRequestResponse = await this.requestLogin();
    const loginInput: LoginInput = {
      email,
      password,
      rememberLogin: false,
      isFastCheckout
    };

    if (loginRequestResponse) {
      const subscription = this.httpClient
        .post(this.urlHelper.idpUrl + '/' + loginRequestResponse.action, loginInput)
        .subscribe(
          (loginResponse: LoginResponse) => {
            if (loginResponse.hasError) {
              this.store.dispatch(new LoginFailure(loginResponse));
            } else {
              const iFrame = window?.document.getElementById('iframe-auth-success') as any;
              iFrame.src = loginRequestResponse.returnUrl;
            }
            subscription.unsubscribe();
          },
          (error: any) => this.store.dispatch(new LoginFailure({ isLoggedIn: false, errors: [error] }))
        );
    }
  }

  loginWithGoogle() {
    this.commonExternalLogin('Google');
  }

  loginWithFacebook() {
    this.commonExternalLogin('Facebook');
  }

  logoff() {
    this.oidcSecurityService.logoff();
    // window.localStorage.clear();
    window?.sessionStorage.clear();
  }

  getuserData() {
    return this.oidcSecurityService.getUserData();
  }

  getUserInfo() {
    return this.oidcSecurityService.getUserinfo();
  }

  private async commonExternalLogin(provider: string) {
    let width = 450;
    let height = 650;
    if (provider !== 'Google') {
      width = 1120;
      height = 864;
    } else if (this.platformService.isMobile()) {
      width = window?.outerWidth;
      height = window?.outerHeight;
    }

    const popup = window?.open(
      this.urlHelper.frontendUrl + '/assets/htmlexternal-login.html',
      '_blank',
      `width=${width}, height=${height}, chrome=yes, centerScreen, titleBar=0`
    );
    const loginRequestResponse = await this.requestLogin();
    if (loginRequestResponse) {
      const url =
        this.urlHelper.idpUrl +
        '/api/identity/account/externallogin' +
        '?provider=' +
        provider +
        '&returnUrl=' +
        encodeURIComponent(loginRequestResponse.returnUrl);
      popup.location.assign(url);
    }
  }

  private async requestLogin(): Promise<LoginRequest> {
    let authUrl: string;

    this.oidcSecurityService.authorize((x) => {
      authUrl = x;
    });

    return { returnUrl: authUrl, action: 'api/identity/account/login' };
  }
}
